import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import VueShortkey from 'vue-shortkey';
import VueTheMask from 'vue-the-mask';
import VuetifyMoney from 'vuetify-money';
import './plugins/fetch';
import './plugins/rules';

Vue.use(VuetifyMoney);
Vue.use(VueTheMask);
Vue.use(VueShortkey);
Vue.config.productionTip = false;

let anoAtual = new Date();
anoAtual = anoAtual.getFullYear();

let app = new Vue({
	router,
	vuetify,
	render: h => h(App),
	data: {
		showAtalhos: false,
		dialog: null,
		drawer: null,
		usuarioLogado: JSON.parse(localStorage.getItem('usuarioLogado')),
		colorHeader: null,
		titleHeader: null,
		//anoSelecionado: JSON.parse(localStorage.getItem('anoSelecionado'))
		anoSelecionado : anoAtual
	}
}).$mount('#app');

export { Vue, app };
